<script lang="ts">
	export let enabled = true;
</script>

<div class:layer-chart-spacing={enabled}>
	<slot />
</div>

<style>
	.layer-chart-spacing {
		min-width: 0;
		box-sizing: border-box;
		padding-right: 16px;
		padding-left: 32px;
	}

	@media (max-width: 480px) {
		.layer-chart-spacing {
			padding-right: 8px;
			padding-left: 24px;
		}
	}
</style>
